import Label from '@zacousticrepo/grommet-v1-custom/components/Label';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history, Link } from 'react-router';
import LoadingControl from '../../../../../components/LoadingControl';
import SelectTable from '../../../../../components/v3/CalibrationScreenV3/SelectTable';
import SurveyQuestion from '../../../../../components/v3/TakingSurvey/SurveyQuestion';
import { ZRole } from '../../../../../generated';
import { pageLoaded, arrayIsNotEmpty, formatDate, getOnlyUnique, isDefined } from '../../../../../utils';
import BackArrowIcon from '../../../../../icons/v3/BackArrowIcon';
import {
    loadQaAuditScreen,
    loadQaSurveyFormQuestions,
    submitQaSurvey
} from '../../QaDashboardScreenActions';

class QaAuditScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateState: false,
            surveyIsSubmitting: false,
            showSelectQaSurveyFormPopup: false,
            showSelectSurveyFormButton: true,
            selectedSurveyForm: undefined,
            surveyResult: {
                surveyFields: []
            },
            comment: undefined
        };
        this.onSubmitSurvey = this.onSubmitSurvey.bind(this);
        this.onSelectOption = this.onSelectOption.bind(this);

        this.showSelectQaSurveyFormPopup = this.showSelectQaSurveyFormPopup.bind(this);
        this.hideSelectQaSurveyFormPopup = this.hideSelectQaSurveyFormPopup.bind(this);

        this.showSelectSurveyFormButton = this.showSelectSurveyFormButton.bind(this);
        this.hideSelectSurveyFormButton = this.hideSelectSurveyFormButton.bind(this);

        this.allRequiredQuestionsAreAnswered = this.allRequiredQuestionsAreAnswered.bind(this);

        this.getSurveyFormNode = this.getSurveyFormNode.bind(this);
    }

    componentDidMount() {
        pageLoaded('QA');
        this.props.dispatch(loadQaAuditScreen(this.props.params?.ticketId));
    }

    backToSearch = () => {
        history.push('/QualityAssurance/status');
    }

    setComment(value) {
        this.setState({ comment: value })
    }

    showSelectQaSurveyFormPopup() {
        this.setState({ showSelectQaSurveyFormPopup: true });
    }

    hideSelectQaSurveyFormPopup(selectedSurveyForms) {
        this.setState({ showSelectQaSurveyFormPopup: false });
        if (isDefined(selectedSurveyForms) && Array.isArray(selectedSurveyForms) && selectedSurveyForms.length > 0) {
            this.props.dispatch(loadQaSurveyFormQuestions(selectedSurveyForms[0].id));
            this.setState({
                selectedSurveyForm: selectedSurveyForms[0],
                showSelectSurveyFormButton: false
            });
        }
    }

    showSelectSurveyFormButton() {
        this.setState({
            showSelectSurveyFormButton: true,
            selectedSurveyForm: undefined,
            surveyResult: {
                surveyFields: []
            },
        });
    }

    hideSelectSurveyFormButton() {
        this.setState({
            showSelectSurveyFormButton: false,
        });
    }

    onSubmitSurvey() {
        const
            {
                selectedSuggestedAudit,
            } = this.props;
        this.setState({ surveyIsSubmitting: true });
        this.state.surveyResult.surveyFormId = this.state.selectedSurveyForm.id;
        this.state.surveyResult.zacousticTicketId = parseInt(this.props.params?.ticketId);
        this.state.surveyResult.auditedAgentId = selectedSuggestedAudit.agentId;
        this.state.surveyResult.comment = this.state.comment;

        this.props.dispatch(submitQaSurvey(this.state.surveyResult, this.backToSearch));

    }

    onSelectOption(surveyQuestionId, maxPoints, surveyQuestionPotentialResponseId, pointValue, isZeroMaker, isNotScored) {
        const surveyField = {
            surveyQuestionId: surveyQuestionId,
            surveyQuestionPotentialResponseId: surveyQuestionPotentialResponseId,
            maxPoints: maxPoints,
            pointValue: pointValue,
            isZeroMaker: isZeroMaker,
            isNotScored: isNotScored
        }

        this.state.surveyResult.surveyFields = this.state.surveyResult.surveyFields.filter(sf => sf.surveyQuestionId != surveyQuestionId);
        this.state.surveyResult.surveyFields.push(surveyField);

        this.setState({ updateState: !this.state.updateState });
    }

    getSelectQaSurveyFormPopup() {
        const
            {
                qaSurveyforms,
            } = this.props;

        if (!qaSurveyforms)
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-qaForms">
                <SelectTable
                    title="Select a survey form:"
                    searchPlaceHolder="Search..."
                    options={qaSurveyforms}
                    onClose={this.hideSelectQaSurveyFormPopup} />
            </div>
        </div>);
    }

    allRequiredQuestionsAreAnswered() {
        const
            {
                qaSurveyFormQuestions,
            } = this.props;
        if (!isDefined(qaSurveyFormQuestions) || !isDefined(this.state.surveyResult.surveyFields))
            return false;

        const isRequiredAnsweredQuestions = qaSurveyFormQuestions.filter(sq => sq.isRequiredAnswered === true);

        const allRespondedQuestionIds = this.state.surveyResult.surveyFields.map(sf => sf.surveyQuestionId);

        let allRequiredAreAnswered = isRequiredAnsweredQuestions.every(v => allRespondedQuestionIds.includes(v.id));

        return allRequiredAreAnswered;
    }

    getSurveyFormNode() {
        const
            {
                qaSurveyFormQuestions,
            } = this.props;
        if (this.state.surveyIsSubmitting === true) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }

        if (isDefined(this.state.selectedSurveyForm) && isDefined(qaSurveyFormQuestions) && Array.isArray(qaSurveyFormQuestions) && qaSurveyFormQuestions.length > 0) {
            let submitSurveyButton;

            const enabledsubmitSurveyButton = (
                <div className="v3-button session-required" style={{ marginLeft: '16px', borderRadius: '10px' }}
                    onClick={this.onSubmitSurvey}>
                    <label className="h3-semibold white-text cursor-pointer">Submit</label>
                </div>);

            const disabledsubmitSurveyButton = (
                <div className="v3-button session-required-disabled" style={{ cursor: 'auto', marginLeft: '16px', borderRadius: '10px' }}>
                    <label className="h3-semibold grey-text" >Submit</label>
                </div >);


            submitSurveyButton = (this.state.surveyIsSubmitting || !this.allRequiredQuestionsAreAnswered())
                ? disabledsubmitSurveyButton : enabledsubmitSurveyButton;

            const sectionsNodes = [];

            var uniqueSurveyFormSection = qaSurveyFormQuestions.map(p => p.surveyFormSection).filter(getOnlyUnique);
            let surveyQuestionNumberInForm = 0;
            uniqueSurveyFormSection.map(surveyFormSection => {
                const questionsOfSection = qaSurveyFormQuestions.filter(p => p.surveyFormSection === surveyFormSection);

                const sectionSurveyQuestionIds = questionsOfSection.map(sqs => sqs.id);
                const sectionSurveyFields = this.state.surveyResult.surveyFields.filter(sfs =>
                    sectionSurveyQuestionIds.includes(sfs.surveyQuestionId));

                let sectionPoints = 0;
                let sectionMaxPoints = 0;
                if (sectionSurveyFields.length > 0) {
                    sectionMaxPoints = sectionSurveyFields.map(sf => sf.maxPoints).reduce((a, b) => a + b);
                    sectionPoints = sectionSurveyFields.map(sf => sf.pointValue).reduce((a, b) => a + b);
                }

                const sectionQuestions = questionsOfSection.map(sq => {
                    surveyQuestionNumberInForm = surveyQuestionNumberInForm + 1;
                    return <SurveyQuestion
                        key={sq.id}
                        surveyQuestion={sq}
                        surveyQuestionNumberInForm={surveyQuestionNumberInForm}
                        onSelectOption={this.onSelectOption}
                        showScore={true} />
                });

                sectionsNodes.push(<div key={surveyFormSection}>
                    <div className="surveyName-title">
                        <span style={{ marginRight: '13px' }}>{surveyFormSection}</span>
                        <span className="title-400-14-16 font-color-secandary-100">Points: {sectionPoints}/{sectionMaxPoints}</span>
                    </div>
                    {sectionQuestions}
                </div>);
            });

            const res = sectionsNodes.map((s, index) => <div key={index}>{s}</div>)


            //let maxPossiblePointsForResponsedQuestions = 0;
            //if (isDefined(this.state.surveyResult.surveyFields) && this.state.surveyResult.surveyFields.length > 0) {
            //    const toScore = this.state.surveyResult.surveyFields
            //        .filter(s => s.isNotScored !== true);
            //    maxPossiblePointsForResponsedQuestions =
            //        toScore.length > 0
            //            ? toScore.map(sf => sf.maxPoints).reduce((a, b) => a + b)
            //            : 0;
            //}

            return (<div>
                <div>
                    {res}
                    <div style={{ margin: '20px 0' }}>
                        <textarea className="survey-comment-text-area"
                            name="postContent"
                            onChange={e => this.setComment(e.target.value)}
                            rows={4} cols={100} />
                    </div>
                    {submitSurveyButton}
                    <br />
                    <br />
                    <br />
                </div >
            </div>);
        }
    }

    render() {
        const
            {
                selectedSuggestedAudit,
                qaSurveyFormQuestions
            } = this.props;

        const backButton = (<div style={{ margin: '4px' }}>
            <Link className="flex " onClick={() => this.backToSearch()}>
                <span className="cursor-pointer" ><BackArrowIcon /></span>
                <Label className="cursor-pointer" style={{ fontSize: '18px', marginLeft: '8px' }} >{'back'}</Label>
            </Link>
        </div>);

        let content = (<LoadingControl />);
        let maxPossiblePoints = 0;
        let earnedPoints = 0;
        if (arrayIsNotEmpty(qaSurveyFormQuestions)) {
            maxPossiblePoints = qaSurveyFormQuestions.map(i => i.maxPoints).reduce((a, b) => a + b);
        }
        if (isDefined(this.state.surveyResult.surveyFields) && this.state.surveyResult.surveyFields.length > 0) {
            const zeroMakerItem = this.state.surveyResult.surveyFields.find(sf => sf.isZeroMaker === true);
            if (!isDefined(zeroMakerItem)) {
                earnedPoints = this.state.surveyResult.surveyFields.map(sf => sf.pointValue).reduce((a, b) => a + b);
            }
        }

        if (isDefined(selectedSuggestedAudit)) {
            const startDateFormatted = formatDate(selectedSuggestedAudit.externalOpenDate);
            content = <div className="sticky">
                <div className="audit-ticket-info-blue-box" style={{ paddingBottom: '15px' }}>
                    <div className="audit-ticket-info-in-row">
                        <div className="audit-ticket-info-margin-agent">
                            <div className="audit-ticket-info-bold-text">{selectedSuggestedAudit.agentName}</div>
                            <div className="audit-ticket-info-blue-text">{selectedSuggestedAudit.agentTeam}</div>
                        </div>
                        <div className="audit-ticket-info-margin-interaction">
                            <tr>
                                <td className="audit-ticket-info-blue-text">Interaction Id:</td>
                                <td>{selectedSuggestedAudit.externalNumber}</td>
                            </tr>
                            <tr>
                                <td className="audit-ticket-info-blue-text">Contact Reason:</td>
                                <td>{selectedSuggestedAudit.reasonForContact}</td>
                            </tr>
                            <tr>
                                <td className="audit-ticket-info-blue-text">Channel:</td>
                                <td>{selectedSuggestedAudit.channelType}</td>
                            </tr>
                        </div>
                        <div className="audit-ticket-info-margin-date">
                            <tr>
                                <td className="audit-ticket-info-blue-text">Start Date:</td>
                                <td>{startDateFormatted}</td>
                            </tr>
                            {/*
                            <tr>
                                <td className="audit-ticket-info-blue-text">End Date:</td>
                                <td>{selectedSuggestedAudit.endDate}</td>
                            </tr>
                            */ }
                            <tr>
                                <td className="audit-ticket-info-blue-text">Handle Time:</td>
                                {selectedSuggestedAudit.totalTimeSpentInSecond && <td>{selectedSuggestedAudit.totalTimeSpentInSecond} seconds</td>}
                            </tr>
                            <tr>
                                <td className="audit-ticket-info-blue-text">JibeIQ:</td>
                                <td>{selectedSuggestedAudit.jibeIQScore}</td>
                            </tr>
                        </div>
                    </div>
                    <table className="audit-ticket-info-table-padding" style={{ width: '-webkit-fill-available', marginLeft: '10%' }}>
                        <thead>
                            <tr>
                                <th className="audit-ticket-info-th">NPS</th>
                                <th className="audit-ticket-info-th">RES</th>
                                {/* <th className="audit-ticket-info-th">CSAT</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="audit-ticket-info-td">{selectedSuggestedAudit.representativeSatisfaction}</td>
                                <td className="audit-ticket-info-td">{selectedSuggestedAudit.resolution}</td>
                                <td className="audit-ticket-info-td">{selectedSuggestedAudit.customerSatisfaction}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {this.state.selectedSurveyForm && <div className="flex survey-name-and-points-box" style={{ padding: '16px' }} >
                    <div onClick={() => this.showSelectSurveyFormButton()} style={{ marginRight: '24px', cursor: 'pointer' }}>
                        <BackArrowIcon />
                    </div>
                    <div>
                        <div className="surveyName-title" style={{ marginBottom: '6px' }}>{this.state.selectedSurveyForm.value}</div>
                        <div className="title-400-14-16 font-color-secandary-100" style={{ marginBottom: '6px' }}>Survey's Max point: {maxPossiblePoints}</div>
                        <div className="title-400-14-16 font-color-secandary-100" style={{ marginBottom: '6px' }}>Points earned: {earnedPoints}</div>
                    </div>
                </div>
                }
            </div>
        }

        const selectReasonForContactPopup = this.state.showSelectQaSurveyFormPopup ? this.getSelectQaSurveyFormPopup() : undefined;

        const surveyFormNode = this.getSurveyFormNode();

        return <div className="main-page-width">
            {backButton}
            {content}
            {selectReasonForContactPopup}
            {this.state.showSelectSurveyFormButton &&
                <div className="title-secandary-400-12-14 cursor-pointer" style={{ margin: '39px 0', fontSize: '24px' }}
                    onClick={this.showSelectQaSurveyFormPopup} >Select a survey form
                </div>
            }
            {surveyFormNode}
        </div>
    }
}

const select = state => ({ ...state.session, ...state.QaDashboardManagerScreen });

export default connect(select)(QaAuditScreen);